// Limite de fotos do plano grátis por projeto (spec S02 §Fotos: "N fotos por
// projeto (valor a definir; proposta inicial 5). Ao atingir, CTA do
// premium."). Constante configurável isolada aqui (não hardcoded na tela)
// porque o valor é "a definir" segundo a spec — mudar o limite não deve
// exigir tocar em UI nem em testes que não sejam sobre o próprio limite.
export const FREE_PLAN_PHOTO_LIMIT = 5;

/**
 * true quando a contagem atual já atingiu (ou passou) o limite — a UI usa
 * isso para bloquear "tirar foto"/"escolher da galeria" e mostrar o CTA de
 * premium em vez de deixar a tentativa de upload falhar.
 */
export function hasReachedPhotoLimit(currentCount: number, limit: number = FREE_PLAN_PHOTO_LIMIT): boolean {
  return currentCount >= limit;
}

/** Quantas fotos ainda cabem antes de atingir o limite (nunca negativo). */
export function remainingPhotoSlots(currentCount: number, limit: number = FREE_PLAN_PHOTO_LIMIT): number {
  return Math.max(0, limit - currentCount);
}
